import React, { useState } from "react";
import Blind_Sample_From from "./blind_Sample_Form/Blind_Sample_From";
import Blind_Sample_table from "./blind_Sample_table/Blind_Sample_table";

function Blind_Sample() {
  const [showTable, setShowTable] = useState(false);

  return (
    <>
      <div className="imperiality_Form_div">
        <Blind_Sample_From onProceed={() => setShowTable(true)} />
      </div>

      {showTable && (
        <div className="imperiality_table_div">
          <Blind_Sample_table/>
        </div>
      )}
    </>
  );
}

export default Blind_Sample;
